export default __webpack_public_path__ + "static/media/certShades.4ab23577.png";